import React from "react"
import "./ResourceBannerCompliance.scss"
import {
  ComplianceCircle,
  ComplianceText,
  complianceNumberConverter,
} from "@swipesense/compliance-helpers"
import PropTypes from "prop-types"
import {
  NR_MIN_OPPORTUNITIES,
  BSR_MIN_OPPORTUNITIES,
} from "../../helpers/sharedConstants"

const ResourceBannerCompliance = ({
  compliance,
  opportunities,
  bsrCompliance,
}) => {
  const convertedComplianceNumber = complianceNumberConverter(
    compliance,
    opportunities,
    bsrCompliance ? BSR_MIN_OPPORTUNITIES : NR_MIN_OPPORTUNITIES
  )

  return (
    <div className="ResourceBannerCompliance">
      <div className="banner-compliance-label">Compliance</div>
      <div className="banner-compliance-data">
        <ComplianceCircle compliance={convertedComplianceNumber} />
        <ComplianceText compliance={convertedComplianceNumber} />
      </div>
    </div>
  )
}

ResourceBannerCompliance.defaultProps = {
  compliance: 0,
  opportunities: 0,
}

ResourceBannerCompliance.propTypes = {
  compliance: PropTypes.number,
  opportunities: PropTypes.number.isRequired,
  bsrCompliance: PropTypes.bool,
}

export default ResourceBannerCompliance
